import { ResolverTag } from '@ps/web-core-enums';
import { useResolver } from '@ps/web-shared-components';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import { FormMethod } from '@swf/core/enums';

import type { RedirectWithContext } from '../../../../../../types/Cashier';

type Props = RedirectWithContext;

const depositKey = 'deposit';
const contextKey = 'context';
const previousDepositKey = 'previousDeposit';
const submitRef = (element: HTMLFormElement) => element && element.submit();

const inputsForKey = (key: string, value: object, skip: string[] = [], base?: string) => {
  const source = value[key as keyof typeof value];

  return (
    source &&
    Object.keys(source)
      .filter((name) => !skip.includes(name))
      .map((name) => (
        <input
          key={`${base ? base + '.' : ''}${key}.${name}`}
          type="hidden"
          name={base ? `${base}[${key}][${name}]` : `${key}[${name}]`}
          value={source[name]}
        />
      ))
  );
};

const RedirectForm: React.FC<Props> = ({ method, url, ...rest }) => {
  const action = useResolver(ResolverTag.SwcCallbackRedirect);
  const [formRef, setFormRef] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const [pageElement] = document.getElementsByTagName('body');
    const element = document.createElement('div');
    element.setAttribute('data-testid', 'redirectFormPortal');
    element.setAttribute('id', 'redirectFormPortalRef');

    pageElement?.appendChild(element);
    setFormRef(element);

    return () => {
      pageElement.removeChild(element);
    };
  }, []);

  const form = (
    <form ref={submitRef} method={FormMethod.Post} action={action}>
      <input type="hidden" name="method" value={method} />
      <input type="hidden" name="url" value={url} />
      {inputsForKey('prms', rest)}
      {inputsForKey(contextKey, rest, [depositKey, previousDepositKey])}
      {inputsForKey(depositKey, rest.context, [], contextKey)}
      {inputsForKey(previousDepositKey, rest.context, [], contextKey)}
    </form>
  );

  return action && formRef ? ReactDOM.createPortal(form, formRef) : null;
};

export default RedirectForm;
